import { useEffect } from 'react'

export function Observer ({ onChange, value }) {
  useEffect(() => {
    onChange(value)
  }, [Object.values(value).join(', ')])
  return null
}

Observer.defaultProps = {
  onChange: () => null
}
